import { SubCategory } from "../Model/SubCategory";
import { SubCategoryRepository } from "../Repository/SubCategoryRepository";



export interface UpdateSubCategoryUseCase {
    invoke: (data: SubCategory) => Promise<boolean>;
  }
  
  export class UpdateSubCategory implements UpdateSubCategoryUseCase {
    private subCategoryRepo: SubCategoryRepository;
    constructor(_SubCategoryRepo: SubCategoryRepository) {
      this.subCategoryRepo = _SubCategoryRepo;
    }
  
    async invoke(data: SubCategory){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.subCategoryRepo.updateSubCategory(data);
        return update;
    }
  }